'use strict';

var React = require('react');
var internalAuthContext = require('../../../../../internal-auth-context-cu8DDA6h.js');

/**
 * Hook to access the {@see InternalAuthHelper} instance provided
 *   by a parent {@see InternalAuthProvider}. This hook can only
 *   be used within a component that is a descendant of said
 *   provider.
 */
var useInternalAuth = function useInternalAuth() {
  return React.useContext(internalAuthContext.InternalAuthContext);
};

exports.useInternalAuth = useInternalAuth;
//# sourceMappingURL=index.js.map
